import type { GetFlowDataRequest, DataFlowResults } from '@rtkwlf/rendall';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useOrganizationContext } from '@packages/legacy/organization-context';
import { MINUTE_IN_MS } from 'ae-constants/constants';

import { useRendallApi } from '../use-rendall-api';

export const getDataFlowQueryKey = (
  organizationId: string,
  request: Omit<GetFlowDataRequest, 'organizationId'>,
) => [organizationId, 'rendall', 'get-data-flow', request];

export const useDataFlow = (
  request: Omit<GetFlowDataRequest, 'organizationId'>,
  options?: Omit<UseQueryOptions<DataFlowResults>, 'queryFn' | 'queryKey'>,
) => {
  const { selectedOrganization } = useOrganizationContext();
  const api = useRendallApi();

  return useQuery({
    queryFn: ({ signal }) =>
      api.getFlowData(
        {
          organizationId: selectedOrganization.id,
          ...request,
        },
        { signal },
      ),
    queryKey: getDataFlowQueryKey(selectedOrganization.id, request),
    staleTime: 5 * MINUTE_IN_MS,
    ...options,
  });
};
